import styled from "styled-components";

export const HeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
`;
